import { render, staticRenderFns } from "./MtDocFormatSettings.vue?vue&type=template&id=7ac6abae&"
import script from "./MtDocFormatSettings.vue?vue&type=script&lang=js&"
export * from "./MtDocFormatSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports